function parseRoomId(roomId) {
  const prefix = 'room_';
  const delimiter = '_';
  function getFloor() {
    let floor = roomId.slice(prefix.length);
    floor = floor.slice(0, floor.indexOf(delimiter));
    return parseInt(floor);
  }

  return {
    getFloor,
  };
}


export default parseRoomId;